export default __webpack_public_path__ + "static/media/forward-button.08a3e1b3.svg";